import(/* webpackMode: "eager", webpackExports: ["default"] */ "/code/components/website/BlogsPage.js");
;
import(/* webpackMode: "eager", webpackExports: ["formatCollectionSubNavLabel"] */ "/code/components/website/CollectionSubNavLinks.js");
